import _ from 'lodash';

export default properties => {
  const extractCropzoneInfo = (cropzone, field, farmId, farmName) => ({
    farmId,
    farmName,
    fieldId: field.id,
    fieldName: field.name,
    cropzoneId: cropzone.id,
    cropzoneName: cropzone.name,
    cropId: cropzone.crop?.id || null,
    cropName: cropzone.crop?.name || cropzone.name || 'Unknown Crop' // Use crop name first, then cropzone name as fallback
  });

  const createCropzoneNode = cz => ({
    key: cz.cropzoneId,
    title: cz.cropzoneName
  });

  const createFieldNode = (fieldCropzones, fieldName, cropId) => {
    const fieldKey = `${fieldCropzones[0].fieldId}-in-${cropId}`;
    return {
      key: fieldKey,
      title: fieldName,
      children: fieldCropzones.map(createCropzoneNode)
    };
  };

  const createFarmNode = (farmCropzones, farmName, cropId) => {
    const farmKey = `${farmCropzones[0].farmId}-in-${cropId}`;

    const fieldGroups = _.chain(farmCropzones)
      .groupBy('fieldName')
      .map((fieldCropzones, fieldName) =>
        createFieldNode(fieldCropzones, fieldName, cropId)
      )
      .value();

    return {
      key: farmKey,
      title: farmName,
      children: fieldGroups
    };
  };

  const getCropId = (cropzones, cropName, unknownCropIds, uniqueCounter) => {
    const firstWithCropId = cropzones.find(cz => cz.cropId);
    if (firstWithCropId?.cropId) return firstWithCropId.cropId;

    if (unknownCropIds.has(cropName)) {
      return unknownCropIds.get(cropName);
    }

    const newId = `crop-${cropName
      .replace(/\s+/g, '-')
      .toLowerCase()}-${uniqueCounter + 1}`;
    unknownCropIds.set(cropName, newId);
    return newId;
  };

  const createCropNode = (
    cropzones,
    cropName,
    unknownCropIds,
    uniqueCounter
  ) => {
    const cropId = getCropId(
      cropzones,
      cropName,
      unknownCropIds,
      uniqueCounter
    );

    const farmGroups = _.chain(cropzones)
      .groupBy('farmName')
      .map((farmCropzones, farmName) =>
        createFarmNode(farmCropzones, farmName, cropId)
      )
      .value();

    return {
      key: cropId,
      title: cropName,
      children: farmGroups
    };
  };

  const flattenedCropzones = _.flatMap(
    properties,
    ({ fields, id: farmId, name: farmName }) =>
      _.flatMap(fields, field =>
        _.map(field.cropzones, cropzone =>
          extractCropzoneInfo(cropzone, field, farmId, farmName)
        )
      )
  );

  const unknownCropIds = new Map();
  const uniqueCounter = 0;

  const groupedByCrop = _.chain(flattenedCropzones)
    .groupBy('cropName')
    .map((cropzones, cropName) =>
      createCropNode(cropzones, cropName, unknownCropIds, uniqueCounter)
    )
    .sortBy('title')
    .value();

  return groupedByCrop;
};
